import { render, staticRenderFns } from "./ModalOsVencidas.vue?vue&type=template&id=9d398d1e&scoped=true&"
import script from "./ModalOsVencidas.vue?vue&type=script&lang=js&"
export * from "./ModalOsVencidas.vue?vue&type=script&lang=js&"
import style0 from "./ModalOsVencidas.vue?vue&type=style&index=0&id=9d398d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d398d1e",
  null
  
)

export default component.exports